// tslint:disable-next-line:export-name
export const DEFAULT_NUMBER_OF_STARS = 5;
export const REVIEW_CATEGORY = 'product reviews / ask answer';
